import { useState } from "react";
import InputsOrder from "./InputsOrder";

export default function SetOrder({
  accountData,
  calculatorInsertRequest,
  marketData,
  symbol,
  selectedSide: controlledSelectedSide,
  onSelectedSideChange,
  onTradeNotification,
  className = "",
}) {
  const [uncontrolledSelectedSide, setUncontrolledSelectedSide] =
    useState("buy");
  const selectedSide = controlledSelectedSide ?? uncontrolledSelectedSide;
  const setSelectedSide =
    onSelectedSideChange ?? setUncontrolledSelectedSide;

  return (
    <div className={`w-full flex flex-col gap-2.5 ${className}`}>
      <div className="relative w-full rounded-[10px] p-0.5 flex gap-1 bg-zi-bg1-light dark:bg-zi-inputbg-dark">
        <span
          aria-hidden="true"
          className={`absolute inset-y-0.5 left-0.5 w-[calc(50%-0.25rem)] rounded-lg transition-[transform,background-color] duration-300 ease-out ${
            selectedSide === "buy"
              ? "translate-x-[calc(100%+0.25rem)] bg-zi-green-dark dark:bg-zi-green-dark/50"
              : "translate-x-0 bg-zi-red-dark dark:bg-zi-red-dark/50"
          }`}
        />

        <button
          type="button"
          onClick={() => setSelectedSide("buy")}
          className={`relative z-[1] w-full rounded-lg py-1 flex justify-center items-center outline-none transition-colors duration-300 ${
            selectedSide === "buy"
              ? "text-white"
              : "text-zi-text-light dark:text-zi-text-dark/50 hocus:dark:text-zi-text-dark/75"
          }`}
        >
          لانگ
        </button>

        <button
          type="button"
          onClick={() => setSelectedSide("sell")}
          className={`relative z-[1] w-full rounded-lg py-1 flex justify-center items-center outline-none transition-colors duration-300 ${
            selectedSide === "sell"
              ? "text-white"
              : "text-zi-text-light dark:text-zi-text-dark/50 hocus:dark:text-zi-text-dark/75"
          }`}
        >
          شورت
        </button>
      </div>

      <InputsOrder
        accountData={accountData}
        calculatorInsertRequest={calculatorInsertRequest}
        marketData={marketData}
        selectedSide={selectedSide}
        symbol={symbol}
        onTradeNotification={onTradeNotification}
      />
    </div>
  );
}
